























import {Component, Vue, Watch} from 'vue-property-decorator';
import ExportDialog from '@/components/Views/Dashboard/Import & Export/ExportDialog.vue';
import PagedTable from '@/components/Views/Dashboard/PagedTable.vue';
import {DateTime} from 'luxon';
import {Mixins} from 'vue-property-decorator';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import {nil} from '@/common';
import SingleAndMultiDashboardPage from '@/components/Views/Dashboard/SingleAndMultiDashboardPage.vue';
import OrderOverview from '@/components/Views/Dashboard/Orders/OrderOverview.vue';
import DashboardOrders from '@/components/Pages/Dashboard/DashboardOrders.vue';

@Component({
    components: {DashboardOrders, OrderOverview, PagedTable, ExportDialog},
})
export default class DashboardCustomers extends Mixins(CurrencyMixin, SingleAndMultiDashboardPage) {
    public selectedPurchasers: any[] = [];
    private search = '';
    @Watch('search')
    public onSearchChanged(value: string, oldValue: string) {
        (this.$refs.table as any).refresh();
    }
    public feathersModel = this.$FeathersVuex.Purchaser;
    public routeParameter = 'purchaser';

    private headers = [
        {
            text: 'Registered On',
            align: 'left',
            sortable: true,
            value: 'createdAt',
            func: (item: any) => DateTime.fromISO(item.createdAt).toFormat('DDDD'),
        },
        {
            text: 'Email',
            align: 'left',
            sortable: true,
            value: 'email',
        },
        {
            text: 'Phone',
            align: 'left',
            sortable: true,
            value: 'phone',
        },
    ];
    public onQuery() {
        if (nil(this.search, true)) { return {}; }
        return {
            $or: [
                {email: {$search: this.search.toString()}},
                {phone: {$search: this.search.toString()}},
            ],
        };
    }
    public customerQuery() {
        return this.hasItem ? {
            purchaser: this.itemBeingViewed._id,
        } : {};
    }
    public get customerTitle() {
        return this.hasItem ? `Orders for ${this.itemBeingViewed.email}` : '';
    }
    public get exportableOrders() {
        return this.selectedPurchasers.map((x) => ({
            _id: x._id,
            email: x.email,
            phone: x.phone,
        }));
    }
    public onView(purchaser) {
        this.$router.push(`customers/${purchaser._id}`);
    }
}
